import React from "react";


function ContactMe() {
    return(
        <div style={{position: "relative", width: "70vw", marginLeft: "auto", marginRight: "auto", marginTop: "10rem"}}>
            <span className='display-large h1' >
                Please feel free to reach out for more details
            </span>
            <span className='headline-large neutrals' style={{marginTop: "1rem"}} >
            I only included the context and solutions in this case study due to restrictions. If you would love to learn more about the process and details, please don't hesitate to reach out! 
            </span>
        </div>
         
        
        
    )
}

export default ContactMe;
